import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api/api.service';
import { map, Observable } from 'rxjs';
import { Pagination } from '../../models/pagination';
import { DealershipDto, DealershipNoIdDto } from '../../models/dealership/dealership-dto';
import { PaginatedResponse, PaginatorFilters } from '@michelin/theme';

@Injectable({
  providedIn: 'root'
})
export class DealershipService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/dealerships`;

  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}

  getPaginatedResponse(pagination: Pagination<DealershipDto>): PaginatedResponse<DealershipDto> {
    return {
      count: pagination.totalElements,
      items: pagination.content
    };
  }

  search(paginatorFilters?: PaginatorFilters): Observable<PaginatedResponse<DealershipDto>> {
    return this.http
      .get<PaginatedResponse<DealershipDto>>(`${this.endpoint}/search${this.apiService.getQueryParams(paginatorFilters)}`)
      .pipe(map((items: Pagination<DealershipDto>) => this.getPaginatedResponse(items)));
  }

  findAll(): Observable<DealershipDto[]> {
    return this.http.get<DealershipDto[]>(`${this.endpoint}/all`);
  }

  findById(dealershipId: number): Observable<DealershipDto> {
    return this.http.get<DealershipDto>(`${this.endpoint}/${dealershipId}`);
  }

  findByAutomakerId(automakerId: number): Observable<DealershipDto[]> {
    return this.http.get<DealershipDto[]>(`${this.endpoint}/automakers/${automakerId}`);
  }

  create(data: DealershipNoIdDto): Observable<DealershipDto> {
    return this.http.post<DealershipDto>(this.endpoint, data);
  }

  update(dealershipId: number, data: DealershipNoIdDto): Observable<DealershipDto> {
    return this.http.put<DealershipDto>(`${this.endpoint}/${dealershipId}`, data);
  }

  upload(file: File, automakerId: number, inactive: Boolean, upperCase: Boolean, specialChar: Boolean) {
    const data = new FormData();
    data.append('file', file);
    data.append('inactive', inactive.toString());
    data.append('upperCase', upperCase.toString());
    data.append('specialChar', specialChar.toString());
    return this.http.post(`${this.endpoint}/upload/automakers/${automakerId}`, data, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  exportExcel(automakerId: number, status: string) {
    return this.http.get(`${this.endpoint}/download/automakers/${automakerId}/status/${status}`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  downloadModelFile() {
    return this.http.get(`${this.endpoint}/download/dealershipModelFile`, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
